<template>
  <div id="app">
    <Header/>
    <DownloadContainer/>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import DownloadContainer from "./components/DownloadContainer.vue";

export default {
  name: "app",
  components: {
    Header,
    DownloadContainer
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "MazdaType";
  src: url("~@/assets/MazdaTypeTT-Medium.eot"),
    url("~@/assets/MazdaTypeTT-Medium.ttf") format("truetype"),
    url("~@/assets/MazdaTypeTT-Medium.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "MazdaType";
  src: url("~@/assets/MazdaTypeTT-Bold.eot"),
    url("~@/assets/MazdaTypeTT-Bold.ttf") format("truetype"),
    url("~@/assets/MazdaTypeTT-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
  margin-bottom:100px;
}

#app {
  font-family: "MazdaType", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  height: 100vh;
  background: #000 url("~@/assets/background-mobile.jpg") no-repeat;
  background-size: cover;
  background-position: center center;
  display: flex;
  flex-direction: column;
  overflow: scroll;

  @media screen and (min-width: 700px) {
    background-image: url("~@/assets/background-desktop.jpg");
  }
}
</style>
